import script from "./NewDiscussionMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewDiscussionMessage.vue?vue&type=script&setup=true&lang=ts"

import "./NewDiscussionMessage.vue?vue&type=style&index=0&id=d2f67d72&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2f67d72"]])

export default __exports__